const Accueil = resolve => {
    require.ensure(['./components/Accueil.vue'], () => {
        resolve(require('./components/Accueil.vue'));
    }, 'Accueil');
}
const Donnees = resolve => {
    require.ensure(['./components/Donnees.vue'], () => {
        resolve(require('./components/Donnees.vue'));
    }, 'Donnees');
}
const Methodologie = resolve => {
    require.ensure(['./components/Methodologie.vue'], () => {
        resolve(require('./components/Methodologie.vue'));
    }, 'Methodologie');
}
const Histoire = resolve => {
    require.ensure(['./components/Histoire.vue'], () => {
        resolve(require('./components/Histoire.vue'));
    }, 'Histoire');
}
const Rapport = resolve => {
    require.ensure(['./components/Rapport.vue'], () => {
        resolve(require('./components/Rapport.vue'));
    }, 'Rapport');
}
const Ressources = resolve => {
    require.ensure(['./components/Ressources.vue'], () => {
        resolve(require('./components/Ressources.vue'));
    }, 'Ressources');
}
const APropos = resolve => {
    require.ensure(['./components/APropos.vue'], () => {
        resolve(require('./components/APropos.vue'));
    }, 'APropos');
}
const Confidentialite = resolve => {
    require.ensure(['./components/Confidentialite.vue'], () => {
        resolve(require('./components/Confidentialite.vue'));
    }, 'Confidentialite');
}
const Confirmation = resolve => {
    require.ensure(['./components/Confirmation.vue'], () => {
        resolve(require('./components/Confirmation.vue'));
    }, 'Confirmation');
}


export const routes = [
    {
        path: '', name: 'Home', components: {
            default: Accueil,
        },
    },
    {
        path: '/confirmation', name: 'Confirmation', components: {
            default: Confirmation,
        },
    },
    {
        path: '/accueil/:address', name: 'Accueil', components: {
            default: Accueil,
        },
    },
    {
        path: '/donnees', name: 'Donnees', components: {
            default: Donnees,
        },
    },
    {
        path: '/methodologie', name: 'Methodologie', components: {
            default: Methodologie,
        },
    },
    {
        path: '/histoire', name: 'Histoire', components: {
            default: Histoire,
        },
    },
    {
        path: '/rapport', name: 'Rapport', components: {
            default: Rapport,
        },
    },
    {
        path: '/Ressources', name: 'Ressources', components: {
            default: Ressources,
        },
    },
    {
        path: '/a-propos', name: 'APropos', components: {
            default: APropos,
        },
    },
    {
        path: '/confidentialite', name: 'Confidentialite', components: {
            default: Confidentialite,
        },
    }
]


// WEBPACK FOOTER //
// ./src/routes.js